import { FilterOptionKeys, GoalImpactLevel } from '@griply/types';
import { TFunction } from 'i18next';
import { ThunderLightning16 } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';

export type Options = {
  t: TFunction;
};

export const noImpactValue = 'none';

export const createGoalImpactFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.GoalImpact,
  label: t('context-menus.filtering.task.filters.goal-impact.title'),
  placeholder: t('general.labels.select'),
  icon: ThunderLightning16,
  type: FilterOptionType.MultiSelect,
  selectOptions: [
    {
      label: t('goal.impact.options.high.label'),
      value: GoalImpactLevel.High,
    },
    {
      label: t('goal.impact.options.medium.label'),
      value: GoalImpactLevel.Medium,
    },
    {
      label: t('goal.impact.options.low.label'),
      value: GoalImpactLevel.Low,
    },
    {
      label: t('context-menus.filtering.task.filters.goal-impact.options.none'),
      value: noImpactValue,
    },
  ],
  canReset: true,
});
